// helpers
import { appSection, initialSelectedCategory, checkRedirection } from "../../utils/panel-helpers/helpers";
import ApiHelper from "../../utils/apiHelper";
// actions
import { globalActionCreators } from "./globalModule";

export const marketplaceActionTypes = {
  CALL_MARKETPLACE_DATA: "CALL_MARKETPLACE_DATA",
  UPDATE_MARKETPLACE_OFFERS: "UPDATE_MARKETPLACE_OFFERS",
  CHANGE_SELECTED_CATEGORY: "CHANGE_SELECTED_CATEGORY",
  TOGGLE_MARKETPLACE_LOADER: "TOGGLE_MARKETPLACE_LOADER",
  RESET_MARKETPLACE: "RESET_MARKETPLACE"
};

export const initialState = {
  marketplaceOffers: [],
  marketplaceCategories: [],
  selectedMarketplaceCategory: initialSelectedCategory,
  isLoadingMarketplace: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case marketplaceActionTypes.CALL_MARKETPLACE_DATA:
      return {
        ...state,
        marketplaceOffers: action.marketplaceOffers,
        marketplaceCategories: action.marketplaceCategories
      };
    case marketplaceActionTypes.UPDATE_MARKETPLACE_OFFERS:
      return {
        ...state,
        marketplaceOffers: state.marketplaceOffers.map(offer => {
          if (offer?.event_code === action?.updatedOffer?.event_code) {
            return action?.updatedOffer;
          } else {
            return offer;
          }
        })
      };
    case marketplaceActionTypes.CHANGE_SELECTED_CATEGORY:
      return {
        ...state,
        selectedMarketplaceCategory: action.selectedMarketplaceCategory
      };
    case marketplaceActionTypes.TOGGLE_MARKETPLACE_LOADER:
      // this is using for non-hotel-group-manager role
      return {
        ...state,
        isLoadingMarketplace: action.isLoadingMarketplace
      };
    case marketplaceActionTypes.RESET_MARKETPLACE:
      return {
        ...state,
        marketplaceOffers: [],
        marketplaceCategories: [],
        selectedMarketplaceCategory: initialSelectedCategory
      };

    default:
      return state;
  }
};

export const marketplaceActionCreators = {
  changeSelectedCategoryAction: selectedMarketplaceCategory => {
    return {
      type: marketplaceActionTypes.CHANGE_SELECTED_CATEGORY,
      selectedMarketplaceCategory
    };
  },
  toggleMarketplaceLoader: isLoadingMarketplace => {
    // this is using for non-hotel-group-manager role
    return {
      type: marketplaceActionTypes.TOGGLE_MARKETPLACE_LOADER,
      isLoadingMarketplace
    };
  },
  // Load Marketplace Data - offers & categories API calls
  loadMarketplaceDataAction: (hotelId, callSectionLoader) => async (dispatch, getState) => {
    const sectionLoadingNamesState = getState().global.sectionLoadingNames;
    if (sectionLoadingNamesState?.includes(appSection?.marketplace)) {
      // disable new API call if we are still waiting for response
      return;
    }
    const isHotelGroupExistsState = getState().home.isHotelGroupExists;
    const hotelIdParam = isHotelGroupExistsState && hotelId ? `?hotelId=${hotelId}` : "";

    callSectionLoader(true, appSection?.marketplace);

    let promises = [];
    const resOffers = ApiHelper.get(`/v1/offers${hotelIdParam}`);
    const resCategories = ApiHelper.get(`/v1/categories${hotelIdParam}`);

    promises.push(resOffers);
    promises.push(resCategories);

    await Promise.all(promises)
      .then(([offersData, categoriesData]) => {
        checkRedirection(offersData.request.responseURL);
        checkRedirection(categoriesData.request.responseURL);

        const marketplaceCategories = categoriesData?.data;
        marketplaceCategories.unshift(initialSelectedCategory);

        dispatch({
          type: marketplaceActionTypes.CALL_MARKETPLACE_DATA,
          marketplaceOffers: offersData?.data,
          marketplaceCategories: marketplaceCategories
        });
      })
      .catch(() => dispatch(globalActionCreators.handleErrorAction()))
      .finally(() => callSectionLoader(false, appSection?.marketplace));
  },
  updateMarketplaceOffersAction: (offer, field, value) => async (dispatch, getState) => {
    const isHotelGroupExistsState = getState().home.isHotelGroupExists;
    let bodyFormData;

    if (field === "concierge") {
      bodyFormData = {
        hotel_concierge_active: value
      };
    }
    if (field === "guestPlatform") {
      bodyFormData = {
        guest_platform_active: value
      };
    }
    if (field === "kiosk") {
      bodyFormData = {
        lobby_kiosk_active: value
      };
    }

    if (isHotelGroupExistsState) {
      const selectedHotelsState = getState().global.selectedHotels;
      bodyFormData = {
        ...bodyFormData,
        hotelId: selectedHotelsState[0]?.id
      };
    }

    try {
      const res = await ApiHelper.patch(`/v1/offers/` + offer?.event_code, {}, JSON.stringify(bodyFormData), {
        "Content-Type": "application/json"
      });

      dispatch({
        type: marketplaceActionTypes.UPDATE_MARKETPLACE_OFFERS,
        updatedOffer: res?.data
      });
    } catch (error) {
      dispatch(globalActionCreators.handleErrorAction());
    }
  },
  resetMarketplaceDataAction: () => {
    return {
      type: marketplaceActionTypes.RESET_MARKETPLACE
    };
  }
};
